import React, { Component } from 'react'
import { observer } from 'mobx-react'

import TasksTable from '../taskstable'

@observer(['globals', 'tasks'])
export default class PartnerTasksTable extends Component {
  constructor(props) {
    super(props)
  }

  onLoadTask(id, callback) {
    this.props.tasks.loadPartnerTask(id, (data) => {
      let dd = new Date(data.dueDate)
      let dateString = dd.getUTCFullYear() + '-' + ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2)

      const loadedTask = {
        id: id,
        taskPriorityId: data.taskPriorityId,
        taskStateId: data.taskStateId,
        task: data.task,
        companyPhone: data.partner.phone,
        companyEmail: data.partner.email,
        assignedUserId: data.assignedUserId,
        assignedUserName: data.assignedUser.firstName + ' ' + data.assignedUser.lastName,
        formattedDueDate: dateString
      }

      if (callback) {
          callback(loadedTask)
      }
    })
  }

  onSaveTask(data, callback) {
    this.props.tasks.updatePartnerTask(data, () => {
      if (callback != null) {
        callback()
      }
    })
  }

  onDeleteTask(id) {
    this.props.tasks.deletePartnerTask(id, (data) => {
      this.reload()
    })
  }

  onMassDueDateSave(data, callback) {
    this.props.tasks.updatePartnerTaskDuedate(data, () => {
      if (callback != null) {
        callback()
      }
    })
  }

  onMassAssignedUserSave(data, callback) {
    this.props.tasks.updatePartnerTaskAssignedUser(data, () => {
      if (callback != null) {
        callback()
      }
    })
  }

  reload(callback) {
    this.props.reload(() => {
      if (callback != null) {
        callback()
      }
    })
  }

  render() {
    return (
      <div>
        <TasksTable data={ this.props.data } hideLocation={ true } hideVendor={ true } hideSource={ true } taskTypeHeading="Partner" taskType="partnerName" reload={ this.reload.bind(this) } onSaveTask={ this.onSaveTask.bind(this) } onDeleteTask={ this.onDeleteTask.bind(this) } onMassDueDateSave={ this.onMassDueDateSave.bind(this) } onMassAssignedUserSave={ this.onMassAssignedUserSave.bind(this) } onLoadTask={ this.onLoadTask.bind(this) } />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/tasks/partnertaskstable.js